export default {"src":"/_next/static/media/bundle-promo-icon.2f2d7eb0.svg","height":50,"width":47,"blurWidth":0,"blurHeight":0};